/* eslint-disable no-underscore-dangle */

'use-strict';

import { IScope } from 'angular';
import { SalesAPIService } from '../../../shared/api/sales-api.service';
import { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { EAvailabilityCode } from '../../../src/app/@shared-types/vehicle/enums';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';

interface RemoveAvailabilityScope extends IScope {
  sending: boolean,
  exitForm: () => void,
  exit: (data: VehicleFormComponentExitFunction) => void,
  formTransmission: () => void,
  vehicle: AutoboardVehicle,
}

/* @ngInject */
export default function RemoveAvailabilityController(
  $scope: RemoveAvailabilityScope,
  salesApiService: SalesAPIService,
): void {
  $scope.sending = false;

  $scope.exitForm = () => {
    $scope.exit({ removeLock: true });
  };

  $scope.formTransmission = async () => {
    $scope.sending = true;

    if ($scope.vehicle.vehicleData.availability.code === EAvailabilityCode.Sold) {
      await salesApiService.deleteSale(String($scope.vehicle._id));
    } else {
      await salesApiService.deleteReservation(String($scope.vehicle._id));
    }

    $scope.exit({});
  };
}
